import React, { useState } from 'react';
import './services.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    faArrowRight,
    faXmark,
    faCheckDouble,
    faTableCellsLarge,
    faCode,
    faDiagramProject
} from '@fortawesome/free-solid-svg-icons';
import portfolioData from '../../portfolio.json';

export default function Services() {
    const [toggleState, setToggleState] = useState(0);
    const { services } = portfolioData;

    const toggleTab = (index) => {
        setToggleState(index);
    };

    const closeModal = () => {
        setToggleState(0);
    };

    const getIcon = (iconName) => {
        switch (iconName) {
            case 'faTableCellsLarge': return faTableCellsLarge;
            case 'faCode': return faCode;
            case 'faDiagramProject': return faDiagramProject;
            default: return faCode;
        }
    }

    return (
        <section className='services section' id="services">
            <h2 className='section__title'>{services.title}</h2>
            <span className='section__subtitle'>{services.subtitle}</span>

            <div className='services__container container grid'>
                {services.items.map((item, index) => (
                    <div className='services__content' key={index}>
                        <div>
                            <FontAwesomeIcon icon={getIcon(item.icon)} className='services__icon' />
                            <h3 className='services__title' dangerouslySetInnerHTML={{ __html: item.title.replace(/\n/g, '<br/>') }}></h3>
                        </div>
                        <span className='services__button' onClick={() => toggleTab(index + 1)}>
                            View More
                            <FontAwesomeIcon icon={faArrowRight} className='services__button-icon' />
                        </span>

                        <div className={toggleState === index + 1 ? "services__modal active-modal" : "services__modal"}>
                            <div className='services__modal-content'>
                                <FontAwesomeIcon
                                    icon={faXmark}
                                    className='services__modal-close'
                                    onClick={closeModal}
                                />
                                <h3 className='services__modal-title'>{item.modalTitle}</h3>
                                <p className='services__modal-description'>
                                    {item.description}
                                </p>
                                <ul className='services__modal-services grid'>
                                    {item.services.map((serviceDesc, i) => (
                                        <li className='services__modal-service' key={i}>
                                            <FontAwesomeIcon icon={faCheckDouble} className='services__modal-icon' />
                                            <p className='services__modal-info'>{serviceDesc}</p>
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </section>
    );
}